<h4 *ngIf="name">{{ name }}</h4>
<p>
  <span *ngIf="street" class="street">{{ street }}</span>
  <br>
  <span *ngIf="zip" class="zip">{{ zip }} </span>

  <span *ngIf="city" class="city">{{ city }}</span>
  <br>
  <span *ngIf="country" class="country">{{ country | translate }}</span>
  <br>
  <span *ngIf="phone" class="phone">Tel. {{ phone }}</span>
</p>
<br/>
<br/>
<app-company-schedule></app-company-schedule>
